import axios from 'axios'
import { notification } from '../../helpers/notification'

export const profileMixin = {
    data() {
        return {
            url: '/api/profile/v1/settings/user',
            profileUrl: '/bookers/',
            deleteProfileUrl: '/profile/user/request-delete/',
            userInfo: {
                first_name: '',
                last_name: '',
                phone_number: '',
                email: '',
                current_password: null,
                description: null,
                timezone: '',
                id: null,
                booker_id: null,
                avatar: '',
                address: '',
                lat: null,
                lon: null
            },
            isFlag: false,
            isFlagConfirm: false,
            isFlagCurrent: false,
            timezones: [],
            userTimezone: [],
            selectedTimezone: '',
            showAccount: false,
            repeatNewPassword: '',
            repeatNewPasswordError: '',
            password: '',
            newPassword: '',
            newPasswordError: '',
            passwordError: '',
            firstName: 'Please enter a valid first name',
            lastName: 'Please enter a valid last name',
            email: 'Please enter a valid email address.',
            phoneNumber: 'Please enter a valid phone number.',
            address: 'Please select from suggestions.',
            description: 'Please enter a bio',
            dismissSecs: 5,
            responseMessage: '',
            alertVariant: '',
            resetPass: false,
            avatar: [],
            id: null,
            load: false,
            emailError: 'Please enter a valid email address.'
        }
    },
    methods: {
        async removeAvatar() {
            try {
                await axios.delete('/api/profile/settings/' + this.userInfo.id + '/delete-image')
                window.location.reload()
            } catch (error) {
                notification('error', error)
            }
        },
        validateFirstName() {
            const strRegex = /^[A-Z][a-zA-Z -]+$/
            if (!strRegex.test(this.userInfo.first_name)) {
                this.firstName = 'Please enter a valid first name'
            } else this.firstName = ''
        },
        validateLastName() {
            const strRegex = /^[A-Z][a-zA-Z -]+$/
            if (!strRegex.test(this.userInfo.last_name)) {
                this.lastName = 'Please enter a valid last name'
            } else this.lastName = ''
        },
        validateDescription() {
            if (this.userInfo.description?.length > 1000 || this.userInfo.description?.length < 1) {
                this.description = 'Please enter a bio'
            } else this.description = ''
        },
        validateAddress() {
            if (!this.userInfo.address || !this.userInfo.lat || !this.userInfo.lon) {
                this.address = 'Please select from suggestions.'
            } else this.addresss = ''
        },
        validateEmail() {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
            if (!emailRegex.test(this.userInfo.email)) {
                this.emailError = 'Please enter a valid email address.'
            } else {
                this.emailError = ''
            }
        },
        viewBookerProfile() {
            window.open(`${this.profileUrl + this.userInfo.booker_id}`, '_blank')
        },
        async deleteUserProfile() {
            try {
                await axios.post(this.deleteProfileUrl + this.userInfo.id)
                notification('success', 'Your request to delete the account has been sent to our support team.')
            } catch (error) {
                console.error('Error sending delete request:', error)
                notification(
                    'error',
                    'There was issue sending your request please try later or contact support directly.'
                )
            }
        },
        async getUserData() {
            const response = await axios.get(this.url)
            this.userInfo = response.data.data[0]
            this.timezones = this.userInfo.timezone
            this.id = this.userInfo.id
            this.userTimezone = this.userInfo.user_timezone
            if (this.userTimezone.length) {
                this.userInfo.timezone = this.userTimezone[0].id
            }
        },
        async editUserData() {
            this.$v.userInfo.$touch()
            if (!this.$v.userInfo.$invalid) {
                this.load = true
                try {
                    const config = {
                        headers: { 'content-type': 'multipart/form-data' }
                    }
                    let formData = new FormData()
                    formData.append('first_name', this.userInfo.first_name)
                    formData.append('last_name', this.userInfo.last_name)
                    formData.append('email', this.userInfo.email)
                    formData.append('phone_number', this.userInfo.phone_number ? this.userInfo.phone_number : '')
                    formData.append('description', this.userInfo.description)
                    formData.append('address', this.userInfo.address)
                    formData.append('lat', this.userInfo.lat)
                    formData.append('lon', this.userInfo.lon)

                    for (let i = 0; i < this.avatar.length; i++) {
                        formData.append('avatar', this.avatar[i])
                    }
                    formData.append('timezone', this.userInfo.timezone)
                    formData.append('_method', 'PUT')
                    const response = await axios.post(
                        '/api/profile/v1/settings/' + this.id + '/update',
                        formData,
                        config
                    )
                    notification('success', 'Settings update successful')
                    this.load = false
                    this.responseMessage = response.data.message
                    this.newPasswordError = ''
                    this.repeatNewPasswordError = ''
                    this.passwordError = ''
                } catch (error) {
                    console.error('here', error)
                    this.load = false
                    if (error.response.data.errors.first_name) this.firstName = error.response.data.errors.first_name[0]
                    if (error.response.data.errors.last_name) this.lastName = error.response.data.errors.last_name[0]
                    if (error.response.data.errors.phone_number)
                        this.phoneNumber = error.response.data.errors.phone_number[0]
                    if (error.response.data.errors.email) this.email = error.response.data.errors.email[0]
                    if (error.response.data.errors.new_password)
                        this.newPasswordError = error.response.data.errors.new_password[0]
                    if (error.response.data.errors.c_new_password)
                        this.repeatNewPasswordError = error.response.data.errors.c_new_password[0]
                    if (error.response.data.errors.password) this.passwordError = error.response.data.errors.password[0]
                    if (error.response.data.message) {
                        this.responseMessage = error.response.data.message
                        notification('error', this.responseMessage)
                    }
                }
            }
        },
        async changePassword() {
            try {
                if (this.userInfo.current_password) {
                    const response = await axios.put('/api/profile/v1/settings/' + this.id + '/update-password', {
                        new_password: this.newPassword,
                        c_new_password: this.repeatNewPassword,
                        password: this.password,
                        first_name: this.userInfo.first_name,
                        last_name: this.userInfo.last_name,
                        email: this.userInfo.email,
                        phone_number: this.userInfo.phone_number,
                        description: this.userInfo.description,
                        timezone: this.userInfo.timezone
                    })
                    notification('success', response.data.message)
                    this.closeModal()
                }
            } catch (error) {
                if (error.response.data.errors.password) this.passwordError = error.response.data.errors.password[0]
                if (error.response.data.errors.new_password)
                    this.newPasswordError = error.response.data.errors.new_password[0]
                if (error.response.data.errors.c_new_password)
                    this.repeatNewPasswordError = error.response.data.errors.c_new_password[0]
            }
        }
    },
    computed: {
        validateAll() {
            return !this.firstName && !this.lastName && !this.emailError
        }
    }
}
